import { format } from "date-fns";
import { toDate } from "./toDate";
import { DEFAULT_DATE_FORMAT } from "../../utils/consts";
export function toDateString(value, formatString) {
    var date = toDate(value);
    if (!date) return undefined;
    return format(date, formatString !== null && formatString !== void 0 ? formatString : DEFAULT_DATE_FORMAT);
}
